import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/service/baozhangfuwu-qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-4ec9c54c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scan-qrcode-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-text" }, "请使用手机微信扫描二维码访问", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-qrcode" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "qrcode-img",
    src: _imports_0,
    alt: "保障服务"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-right" }, null, -1))

import { ref } from 'vue'
import appHost from '@/utils/app'
import { useRouter } from 'vue-router'
import { usePlatformInfo } from '@/compositions/common'
import Header from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const listWrap = ref([
  { title: '意外机损保险', key: 'jijia' },
  { title: '第三者责任险', key: 'three' },
])

const { isSrc4Device, isLandscape } = usePlatformInfo()
const $router = useRouter()

function clickHandle(item: { key: string }) {
  if (item.key === 'jijia') {
    jijiaHandle()
  } else if (item.key === 'three') {
    threeLiabilityHandle()
  }
}

function onLeftClick(): void {
  appHost.goAppBack()
}
// 跳转购买安心保
function jijiaHandle() {
  $router.push({
    name: 'insurance-jijia-introduce',
  })
}
// 查看三责险
function threeLiabilityHandle() {
  $router.push({
    name: 'three-liability-insurance-aggregation',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      title: "保障服务",
      isReturnLeftEvent: "",
      onLeftClick: onLeftClick
    }),
    (_unref(isSrc4Device))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["list-wrap", _unref(isLandscape) ? 'list-landscape-wrap' : ''])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listWrap.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              onClick: ($event: any) => (clickHandle(item))
            }, [
              _createElementVNode("div", null, _toDisplayString(item.title), 1),
              _hoisted_6
            ], 8, _hoisted_5))
          }), 128))
        ], 2))
  ], 64))
}
}

})